export class AdminCampaignTemplateController {
  constructor($scope, CampaignTemplateService) {
    $scope.vm = this;
    $scope.page = 1;
    $scope.limit = 12;
    $scope.total = 0;
    $scope.allTemplatesSelected = { state: false };
    $scope.templateSelected = {};
    this.scope = $scope;
    this.scope.allTemplates = [];
    this.scope.show = {
      create: false,
      read: false,
      update: false
    };
    this.CampaignTemplateService = CampaignTemplateService;
    this.scope.templateFormModel = {
      name: '',
      content: ''
    };
    this.init()
  }

  init() {
    this.scope.getCampaigns = (page) => {
      this.scope.page = page;
      this.CampaignTemplateService.getCampaignTemplateList(this.scope.page, this.scope.limit)
        .then((response) => { let data = response.data;
          this.scope.total = data.itemCount;
          this.scope.allTemplates = data.data;
          this.scope.templateSelected = {};

          _.forEach(this.scope.allTemplates, (template) => {
            this.scope.templateSelected[template._id] = false;
          });

          this.scope.allTemplatesSelected.state = false;
        })
        .catch((response) => { let err = response.data;
          console.log(err);
        })
    }

    this.scope.selectAllTemplates = () => {
      var check = this.scope.allTemplatesSelected.state;

      _.forEach(this.scope.templateSelected, (template, key) => {
        this.scope.templateSelected[key] = !!check;
      })
    }

    this.scope.changeCrudView = (view) => {
      this.scope.show.create = false;
      this.scope.show.read = false;
      this.scope.show.update = false;

      if(view == 'create') {
        this.scope.templateFormModel = {
          name: '',
          content: ''
        };
      }

      this.scope.show[view] = true;
    }

    this.scope.changeCrudView('read');
    this.scope.getCampaigns(this.scope.page, this.scope.limit);

    this.scope.editCampaignTemplate = (template) => {
      this.scope.templateFormModel = angular.copy(template);
      this.scope.changeCrudView('update');
    }

    this.scope.updateCampaignTemplate = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if(key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if(keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      });

      if(this.scope.errors.length) {
        return false;
      }

      this.CampaignTemplateService.updateCampaignTemplate(this.scope.templateFormModel)
        .then((response) => { let data = response.data;
          this.scope.changeCrudView('read');
          this.scope.getCampaigns(this.page);
        }).catch((response) => { let e = response.data;
          console.log(e);
        });
    }

    this.scope.createTemplateCampaign = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if(key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if(keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      });

      if(this.scope.errors.length) {
        return false;
      }

      this.CampaignTemplateService.createCampaignTemplate(this.scope.templateFormModel)
        .then((response) => { let data = response.data;
          this.scope.changeCrudView('read');
          this.scope.getCampaigns(1);
        }).catch((response) => { let e = response.data;
          console.log(e);
        });
    }

    this.scope.removeCampaignTemplates = () => {
      var countdown = 0;
      _.forEach(this.scope.templateSelected, (val, key) => {
        if (val) {
          countdown++;
          this.CampaignTemplateService.removeCampaignTemplate(key)
            .then((response) => { let data = response.data;
              countdown--;
              if (countdown == 0) {
                this.scope.getCampaigns(1);
              }
            }).catch((response) => { let e = response.data;
              countdown--;
              if (countdown == 0) {
                this.scope.refreshPage();
              }
              console.log(e);
            });
        }
      })
    }
  }
}
